import { render, staticRenderFns } from "./ModalReservations.vue?vue&type=template&id=febe6b5a&scoped=true"
import script from "./ModalReservations.vue?vue&type=script&lang=js"
export * from "./ModalReservations.vue?vue&type=script&lang=js"
import style0 from "./ModalReservations.vue?vue&type=style&index=0&id=febe6b5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febe6b5a",
  null
  
)

export default component.exports